module.exports = __webpack_public_path__ + "static/media/SecurityGuardandCCTV24_7.1bf81c2d.svg";